/*
 * Quick-buy modal: close on successful add to cart.
 *
 * The theme's compiled <quick-buy-modal> (in theme.js) only listens for
 * "dialog:after-hide"; it does NOT close itself when an item is added. So after
 * adding from a product-card quick buy — or from a "we recommend" card inside
 * the cart drawer — the modal stays open on top of the cart drawer.
 *
 * On a successful add the product form dispatches a bubbling "variant:add"
 * event (see ProductForm in theme.js). We catch it at the document level, find
 * the quick-buy modal it came from, and hide it. The cart drawer still opens as
 * usual — it reacts to the separate "cart:change" event, which we don't touch.
 */
(function () {
  document.addEventListener('variant:add', function (event) {
    // variant:add is dispatched on the product form, which is a light-DOM
    // descendant of the quick-buy modal it lives in, so closest() resolves it
    // for both the on-page quick buy and the cart-drawer recommendation cards.
    var modal = null;
    var target = event.target;
    if (target && target.closest) {
      modal = target.closest('quick-buy-modal');
    }

    // Fallback: if the event path didn't resolve to a modal, close whichever
    // quick-buy modal happens to be open.
    if (!modal) {
      modal = document.querySelector('quick-buy-modal[open]');
    }

    if (modal && modal.open && typeof modal.hide === 'function') {
      modal.hide();
    }
  });
})();
